import { render, staticRenderFns } from "./UserGroupAccessReport.vue?vue&type=template&id=1b36cb8a&"
import script from "./UserGroupAccessReport.vue?vue&type=script&lang=js&"
export * from "./UserGroupAccessReport.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupAccessReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports